var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3"},[(_vm.subscriptionPrice)?_c('div',[(_vm.purchaseSuccessful)?_c('div',[_c('user-subscription-successful')],1):_c('div',[_c('user-subscription-details'),_c('user-subscription-payment')],1)]):_c('div',[_c('generic-loading')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }